import {GalleryImageModel} from './gallery-image.model';

export class GalleryModel {
  id?: number;
  title?: string;
  imageUrl?: string;
  imageUrlFilePath?: string;
  galleryImages?: GalleryImageModel[] = [];
}
